export default "/ressources/logged/img/icon/svg/google-authenticator.svg";